module.exports = __webpack_public_path__ + "img/img_case_index_02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/case/img_case_index_02.jpg
// module id = 783
// module chunks = 0